'use strict'

const isPlainObject_ = require('lodash/isPlainObject')

const RESOLVER_KEY = require('./resolverKey')
const RESOLVER_VALUE = 'dataBinding'

module.exports.addResolver = filterExpression =>
  Object.assign({}, filterExpression, { [RESOLVER_KEY]: RESOLVER_VALUE })

module.exports.shouldResolve = filterExpression =>
  isPlainObject_(filterExpression) &&
  filterExpression[RESOLVER_KEY] === RESOLVER_VALUE
